module.exports = __webpack_public_path__ + "img/click2fit.8843e576.svg";